import cn from "./cn";

/** Panel — spesifikasi .panel Design System KLH/BPLH v2.1 (surface, garis, radius 16, elevasi 1). */
export default function Panel({ as: Tag = "div", className, children, ...props }) {
  return (
    <Tag className={cn("rounded-ds-lg border border-line bg-surface shadow-ds-1", className)} {...props}>
      {children}
    </Tag>
  );
}
